module.exports = __webpack_public_path__ + "static/img/manual-22.1675b31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-22.png
// module id = arw0
// module chunks = 4